import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CAMERA_MOTIONS } from '../../../models/video-settings.model';
import { I18nService } from '../../../i18n/i18n.service';

export interface VideoSettingsCameraOnly {
  cameraMotion: string;
}

@Component({
  selector: 'app-video-settings-camera-only',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './video-settings-camera-only.component.html',
  styleUrls: ['./video-settings-camera-only.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => VideoSettingsCameraOnlyComponent),
      multi: true
    }
  ]
})
export class VideoSettingsCameraOnlyComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Output() settingsChange = new EventEmitter<VideoSettingsCameraOnly>();

  settings: VideoSettingsCameraOnly = {
    cameraMotion: ''
  };

  cameraMotions = CAMERA_MOTIONS;

  constructor(public i18n: I18nService) {}

  private onChange = (_value: VideoSettingsCameraOnly) => { };
  private onTouched = () => { };

  writeValue(value: VideoSettingsCameraOnly): void {
    if (value) {
      this.settings = { ...value };
    } else {
      this.settings = { cameraMotion: '' };
    }
  }

  registerOnChange(fn: (value: VideoSettingsCameraOnly) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSettingChange(): void {
    this.onChange(this.settings);
    this.settingsChange.emit(this.settings);
    this.onTouched();
  }
}